import React from 'react'
import { Menu, Container, Breadcrumb } from 'semantic-ui-react'
import UserForm from '../../Components/Form'

function CreateVehicle(props) {

    return (
        <Container>
            <Menu secondary>
                <Breadcrumb>
                    <Breadcrumb.Section link href="/">Главная</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section link href="/settings/users">Пользователи</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>{props.match.params.id}</Breadcrumb.Section>
                </Breadcrumb>
            </Menu>
            <UserForm id={props.match.params.id} />
        </Container>
    )
}

export default CreateVehicle